<div class="column-form" [formGroup]="form">
    <app-simple-checkbox-value-accessor [label]="column.label" formControlName="select">
    </app-simple-checkbox-value-accessor>
    <app-simple-multiple-search-select-value-accessor label="Typy zdarzeń"
                                                      [data]="eventTypes"
                                                      appearance="standard"
                                                      formControlName="eventTypeIds"></app-simple-multiple-search-select-value-accessor>
    <div></div>
    <mat-error *ngIf="columnForm.invalid">Nie wybrano typów zdarzeń</mat-error>
</div>
